// components/FloatingProductsBackground.jsx
import React from 'react';
import crocko from '../images/crocko.png';
import ulitka from '../images/ulitka.png';
import babochka from '../images/babochka.png';
import etsyFoxi from '../images/etsy_foxi_sits1 copy.png';
import girlCapBag from '../images/girl_cap_bag copy.png';
import medved from '../images/medved copy.png';
import yellow_woman_lack_dog from '../images/yellow_woman_lack_dog.png';
import skateboard from '../images/skateboard1 copy.png';
import tiger from '../images/tiger copy.png';
import '../styles/FloatingProductsBackground.css';

const floatingImages = [
    { src: crocko, alt: 'Crocko', className: 'floating-product-1' },
    { src: ulitka, alt: 'Ulitka', className: 'floating-product-2' },
    { src: babochka, alt: 'Babochka', className: 'floating-product-3' },
    { src: etsyFoxi, alt: 'Etsy Foxi', className: 'floating-product-4' },
    { src: girlCapBag, alt: 'Girl with Cap and Bag', className: 'floating-product-5' },
    { src: medved, alt: 'Medved', className: 'floating-product-6' },
    { src: yellow_woman_lack_dog, alt: 'yellow_woman_lack_dog', className: 'floating-product-7' },
    { src: skateboard, alt: 'Skateboard', className: 'floating-product-8' },
    { src: tiger, alt: 'Tiger', className: 'floating-product-9' },
];

const FloatingProductsBackground = () => {
    return (
        <div className="floating-products-background">
            {floatingImages.map((image) => (
                <div
                    key={image.className}
                    className={`floating-product ${image.className}`}
                >
                    <img
                        src={image.src}
                        alt={image.alt}
                        loading="lazy"
                    />
                </div>
            ))}
        </div>
    );
};

export default FloatingProductsBackground;